import React from 'react';

const RootsPanda = (props) => {
  const { radius, cells } = props;
  const base = cells[1].background;

  return (
    <svg width={`${radius * 1.91}px`} height={`${radius * 0.52}px`} x={`-${radius *.95}px`} y={`-${radius * 1.2}px`} viewBox="0 0 191 52" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Canvas" transform="translate(-23 -24)">
        <g id="Intersect">
          <use xlinkHref="#path0_fill" transform="translate(23.3763 24.366)" fill={base} />
        </g>
        <g id="Intersect">
          <use xlinkHref="#path1_fill" transform="translate(150.494 24.3661)" fill={base} />
        </g>
      </g>
      <defs>
        <path id="path0_fill" fillRule="evenodd" d="M 16.9342 4.52564C 33.1118 -4.79636 53.7912 0.744246 63.1298 16.9057L 4.53776 50.7058C -4.8008 34.5445 0.736612 13.8799 16.905 4.54244C 16.9099 4.53955 16.9148 4.53693 16.9197 4.53404C 16.9245 4.53115 16.9294 4.52853 16.9342 4.52564Z" />
        <path id="path1_fill" fillRule="evenodd" d="M 58.592 50.7057C 67.9334 34.5395 62.3898 13.8675 46.21 4.53393C 30.0303 -4.79962 9.34136 0.739414 0 16.9056L 58.592 50.7057Z" />
      </defs>
    </svg>
  )
}
export default RootsPanda;

export const RootsPandaOverlay = (props) => {
  const { radius, cells, generations } = props;
  const base = cells[1].background;
  return (
    <svg width={`${radius * 1.91}px`} height={`${radius * 0.52}px`} x={`-${radius * .135}px`} y={`-${radius * .13}px`} viewBox="0 0 191 52" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Canvas" transform="translate(-86 -103)">
        <g id="Nose3">
          <use xlinkHref="#ov_path0_fill" transform="translate(86 103)" fill={base} />
        </g>
      </g>
      <defs>
        <path id="ov_path0_fill" d="M 20.0005 28.0939C 17.4882 28.0939 15.4445 26.1252 15.4445 23.7065L 15.3351 15.158C 18.7214 14.3394 21.2387 11.3122 21.2387 7.69153C 21.2387 3.44388 17.7766 0 13.5065 0C 9.23637 0 5.77429 3.44388 5.77429 7.69153C 5.77429 11.3753 8.37862 14.4494 11.8544 15.2025L 11.745 23.7065C 11.745 26.1252 9.7013 28.0939 7.18896 28.0939C 4.67661 28.0939 2.63168 26.1252 2.63168 23.7065L 0 23.7065C 0 27.5695 3.22589 30.7105 7.18896 30.7105C 9.98473 30.7105 12.4076 29.1437 13.5947 26.8672C 14.7832 29.1437 17.2048 30.7105 20.0005 30.7105C 23.9636 30.7105 27.1895 27.5683 27.1895 23.7065L 24.5578 23.7065C 24.5578 26.1252 22.5141 28.0939 20.0005 28.0939Z" />
      </defs>
    </svg>
  )
}

export function resize(props) {
  const { radius, minY, maxY } = props;
  return {
    ...props,
    minY: minY + radius * .3,
    maxY: maxY + radius * .1,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/rootstech/panda.js